export enum DateRangeControl {
  Min = 'min',
  Max = 'max',
}
